import { Button, Stack } from "@mui/material";
import { GridActionsCellItem, GridColDef, GridRowParams } from "@mui/x-data-grid-premium";
import { useContext, useEffect, useMemo, useState } from "react";
import { ModalContext } from "../../../../Components/Modals";
import ModalCreateOrUpdateResource, {
    ModalCreateOrUpdateResourceElementProps,
} from "../../../../Components/Modals/ModalCreateOrUpdateResource/modal-create-or-update-resource";
import DataTable, { CellSize } from "../../../../Components/Table/table";
import TableCellBool from "../../../../Components/Table/TableCellBool";
import TableCellResourceLocation from "../../../../Components/Table/TableCellResourceLocation/table-cell-resource-location";
import TableCellStringExpend from "../../../../Components/Table/TableCellStringExpend/table-cell-string-expend";
import { planningUserTaskService } from "../../../../Core/Api/services";
import { DbOrderManualTaskPlanningResourceInfos } from "../../../../Core/Api/Types/db-order-manual-task-planning-resource-infos";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ModalConfirmAction, {
    ModalConfirmActionElementProps,
} from "../../../../Components/Modals/ModalConfirmAction/modal-confirm-action";
import ListPageHeader, { ListPageHeaderLeft, ListPageHeaderRight } from "../../../../Components/Misc/ListPageHeader";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import TableUuids from "../../../../Components/Table/table-uuids";

function AdminSettingsPlanningResources() {
    const { t } = useTranslation();
    const modalContext = useContext(ModalContext);
    const { openModal } = { ...modalContext };

    const [isLoading, setIsLoading] = useState(true);

    const [resources, setResources] = useState<DbOrderManualTaskPlanningResourceInfos[]>([]);

    const handleNewResourceClick = () => {
        if (!openModal) return;
        openModal<ModalCreateOrUpdateResourceElementProps>(ModalCreateOrUpdateResource, {
            mode: "create",
            availableResources: resources,
        });
    };

    const handleEditResourceClick = (resourceId: number) => {
        if (!openModal) return;
        console.log(resources);
        openModal<ModalCreateOrUpdateResourceElementProps>(ModalCreateOrUpdateResource, {
            mode: "update",
            resourceToUpdate: resources.find((r) => r.id === resourceId)!,
            availableResources: resources,
        });
    };

    const handleDeleteResourceClick = (resourceId: number) => {
        if (!openModal) return;
        openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
            title: t("modal:title.confirmResourceDeletion"),
            onConfirm: () => planningUserTaskService.DeleteResource(resourceId),
        });
    };

    const resourcesColumns: GridColDef[] = useMemo(
        () => [
            {
                headerName: t("common:name"),
                field: "name",
                flex: CellSize.large,
                minWidth: CellSize.large,
                renderCell: (data) => <TableCellStringExpend data={data} />,
            },
            {
                headerName: t("common:type"),
                field: "type",
                flex: CellSize.medium,
                minWidth: CellSize.medium,
                renderCell: (data) => <TableCellStringExpend data={data} />,
            },
            {
                headerName: t("common:location"),
                field: "location",
                flex: CellSize.small,
                minWidth: CellSize.small,
                renderCell: (data) => <TableCellResourceLocation location={data.value} />,
            },
            {
                headerName: t("common:quantity"),
                field: "quantity",
                flex: CellSize.small,
                minWidth: CellSize.small,
                //renderCell: (data: Row) => <AssetTypeChip type={data.value} />,
            },
            {
                headerName: t("table:headerName.calendarQuestionMark"),
                field: "calendar",
                flex: CellSize.small,
                minWidth: CellSize.small,
                renderCell: (data) => <TableCellBool value={data.value} />,
            },
            {
                field: "actions",
                headerName: "",
                type: "actions",
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        icon={<ModeEditOutlinedIcon />}
                        label={t("common:editUpperCase")}
                        onClick={() => handleEditResourceClick(params?.row?.id)}
                    />,
                    <GridActionsCellItem
                        icon={<DeleteOutlinedIcon color="error" />}
                        label={t("common:delete")}
                        onClick={() => handleDeleteResourceClick(params?.row?.id)}
                    />,
                ],
            },
        ],
        [resources]
    );

    useEffect(() => {
        setIsLoading(true);
        planningUserTaskService.GetResourceList().then((response) => {
            setResources(response.resources || []);
            setIsLoading(false);
        });
    }, []);

    const additionalActions = (
        <>
            <Button variant="contained" onClick={handleNewResourceClick} startIcon={<AddIcon />}>
                {t("button:newResource")}
            </Button>
        </>
    );

    return (
        <DataTable
            loading={isLoading}
            tableKey={TableUuids.SETTINGS_PLANNING_RESOURCES}
            rows={resources}
            columns={resourcesColumns}
            additionalActions={additionalActions}
            getRowHeight={() => "auto"}
        />
    );
}

export default AdminSettingsPlanningResources;
